/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-underscore-dangle */
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useDispatchToStore } from '@hooks/reduxHooks';
import { sendFreeVideoWatched, updateView } from '@actions/classes';
import H6 from '@base/H6/H6';
import Close from '@icon/Close';
import { BgColors, Spacings } from '../../../styleConstants';
import YoutubePlayer from './YoutubePlayer';
import Player from './Player';

const Wrapper = styled.div`
  height: ${({ fullHeight }) => (fullHeight ? '100vh' : '423px')};
  background: ${BgColors.BLACK};
  position: relative;
  @media only screen and (max-width: 47.95em) {
    height: 203px;
  }
`;

const DownloadWrapper = styled.div`
  position: absolute;
  bottom: 20%;
  right: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  padding: ${Spacings.SPACING_2B};
  cursor: pointer;
  h6 {
    padding-left: ${Spacings.SPACING_2B};
  }
`;

const InnerDiv = styled.div`
  height: ${({ fullHeight }) => (fullHeight ? '100vh' : '423px')};
  background: ${BgColors.BLACK};
  @media only screen and (max-width: 47.95em) {
    height: 203px;
  }
`;

const FreeLessonFrame = ({ lessonDetails, user, isEmbed }) => {
  const dispatch = useDispatchToStore();
  const { key, cdnUrl, videoType, youtubeId } = lessonDetails;
  const strKey = `unacademy_player_async_${key}`;
  const [showDownload, setShowDownload] = useState(false);

  const updateViewCount = () => {
    dispatch(updateView(lessonDetails.uid));
  };

  const videoWatched = () => {
    dispatch(sendFreeVideoWatched(lessonDetails.uid));
  };

  const onVideoEnd = () => {
    // goto next lesson
  };

  const onPdfClick = () => {
    window.open(lessonDetails.pdfUrl, '_blank');
  };

  const actions = {
    updateViewCount,
    videoWatched,
    onVideoEnd
  };
  const player = new Player(lessonDetails, actions, user);
  useEffect(() => {
    window._unq = window._unq || [];
    if (lessonDetails.hasWatched) {
      // webengage event
    }
    player.setup();
    setTimeout(() => setShowDownload(true), 5000);
    return () => {
      player.unmount();
    };
  }, [key]);
  return (
    <Wrapper fullHeight={isEmbed}>
      {!isEmbed && showDownload ? (
        <DownloadWrapper>
          <Close
            size="16px"
            color={BgColors.WHITE}
            onClick={() => setShowDownload(false)}
          />
          <H6 color={BgColors.WHITE} onClick={onPdfClick}>
            Download PDF
          </H6>
        </DownloadWrapper>
      ) : null}
      {videoType === 2 ? (
        <YoutubePlayer videoId={youtubeId} />
      ) : (
        <InnerDiv className={strKey} data-url={cdnUrl} fullHeight={isEmbed} />
      )}
    </Wrapper>
  );
};

export default FreeLessonFrame;

FreeLessonFrame.propTypes = {
  lessonDetails: PropTypes.objectOf(PropTypes.any).isRequired,
  user: PropTypes.objectOf(PropTypes.any).isRequired,
  isEmbed: PropTypes.bool
};

FreeLessonFrame.defaultProps = {
  isEmbed: false
};
